module.exports = __webpack_public_path__ + "static/eve-a41219154b15e6208f838c26f614b4cb.png";